export default "__VITE_ASSET__CZep9QxR__"